(() => {
  if (customElements.get('sleepy-google-proof')) return;

  const targets = new Set();
  let queued = false;
  let lastSource = '';
  let cachedData = null;
  const parseSource = (source) => {
    if (source === lastSource) return cachedData;
    lastSource = source;
    cachedData = null;
    const marker = source.indexOf('_appioGoogleReviewsData');
    const start = source.indexOf('{', marker);
    if (marker < 0 || start < 0) return null;
    let depth = 0;
    let inString = false;
    let escaped = false;
    for (let index = start; index < source.length; index += 1) {
      const character = source[index];
      if (inString) {
        if (escaped) escaped = false;
        else if (character === '\\') escaped = true;
        else if (character === '"') inString = false;
      } else if (character === '"') inString = true;
      else if (character === '{') depth += 1;
      else if (character === '}' && --depth === 0) {
        try { cachedData = JSON.parse(source.slice(start, index + 1)); } catch (_) { cachedData = null; }
        return cachedData;
      }
    }
    return null;
  };
  const readSummary = () => {
    const data = typeof window._appioGoogleReviewsData !== 'undefined'
      ? window._appioGoogleReviewsData
      : parseSource(document.getElementById('appio_google_reviews_script')?.textContent || '');
    const place = data?.place;
    if (!place) return null;
    const ratingValue = place.ratings ?? place.rating;
    const countValue = place.total ?? place.reviewCount;
    const numeric = (value) => (typeof value === 'number' || (typeof value === 'string' && value.trim() !== '')) ? Number(value) : NaN;
    const rating = numeric(ratingValue);
    const count = numeric(countValue);
    if (!Number.isFinite(rating) || rating <= 0 || rating > 5 || !Number.isSafeInteger(count) || count <= 0) return null;
    return { rating, count };
  };
  const replace = (template, rating, count) => template.replaceAll('__rating__', rating).replaceAll('__count__', count);
  const refresh = () => {
    queued = false;
    const summary = readSummary();
    targets.forEach((target) => target.update(summary));
  };
  const schedule = () => {
    if (queued) return;
    queued = true;
    queueMicrotask(refresh);
  };
  const isSourceNode = (node) => node.nodeType === 1 && (
    node.id === 'appio_google_reviews_script' ||
    node.matches?.('script[src*="appio"], [id^="appio-google"], [class*="agrs__"]') ||
    node.querySelector?.('#appio_google_reviews_script, script[src*="appio"], [class*="agrs__"]')
  );
  const observer = new MutationObserver((records) => {
    if (records.some((record) => record.target.id === 'appio_google_reviews_script' ||
      record.target.parentElement?.id === 'appio_google_reviews_script' ||
      Array.from(record.addedNodes).some(isSourceNode) ||
      Array.from(record.removedNodes).some(isSourceNode))) schedule();
  });
  observer.observe(document.documentElement, { childList: true, subtree: true, characterData: true });
  document.addEventListener('load', (event) => {
    if (isSourceNode(event.target)) schedule();
  }, true);
  document.addEventListener('DOMContentLoaded', schedule);
  document.addEventListener('shopify:section:load', schedule);
  window.addEventListener('pageshow', schedule);
  window.addEventListener('load', schedule);

  customElements.define('sleepy-google-proof', class extends HTMLElement {
    connectedCallback() {
      this.hidden = true;
      targets.add(this);
      schedule();
    }
    disconnectedCallback() { targets.delete(this); }
    update(summary) {
      if (!summary) {
        this.hidden = true;
        this.lastSummary = '';
        return;
      }
      const key = `${summary.rating}/${summary.count}`;
      if (this.lastSummary !== key) {
        const rating = summary.rating.toFixed(1);
        let count;
        try { count = new Intl.NumberFormat(document.documentElement.lang || 'en-NZ').format(summary.count); }
        catch (_) { count = String(summary.count); }
        this.querySelector('[data-google-proof-rating]').textContent = rating;
        this.querySelector('[data-google-proof-count]').textContent = replace(this.dataset.countTemplate, rating, count);
        this.querySelector('[data-google-proof-stars]').style.width = `${summary.rating / 5 * 100}%`;
        this.querySelector('a').setAttribute('aria-label', replace(this.dataset.labelTemplate, rating, count));
        this.lastSummary = key;
      }
      this.hidden = false;
    }
  });
})();
